export const defaultDateFormat = 'MM/DD/YYYY hh:mm A';
export const shortDateFormat = 'MM/DD/YY HH:mm';

export default {};
